import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { FlexRow, FlexRowSpaced } from "../../Styles";
import VideoPlayerProps from "../VideoPlayer";
import SettingsDropdown from "./SettingsDropdown";
import VolumeDropDown from "./VolumeDropDown";

const ControlsButton = ({
  controlsButtonList,
  isVolumeShow,
  setIsVolumeShow,
  setVolume,
  volume,
  isSettingsShow,
  setIsSettingsShow,
  playbackSpeed,
  setPlaybackSpeed,
  isViewOnly,
}: VideoPlayerProps.ControlsButtonProps) => {
  const { Color } = useTheme();

  return (
    <Container $isVolumeShow={isVolumeShow} $isSettingsShow={isSettingsShow}>
      {Array.from({ length: 2 }).map((_, index) => (
        <FlexRow $gapInPx={8} key={index}>
          {controlsButtonList
            .slice(index * 3, (index + 1) * 3)
            .map(({ disabled, iconType, onClick }, index) => (
              <Components.IconButton
                key={index}
                kind="Secondary"
                iconType={iconType}
                size="XS"
                disabled={disabled}
                onClick={onClick}
                IconButtonColor={Color.icon["icon-inverse"].value}
                tabIndex={index}
              />
            ))}
        </FlexRow>
      ))}
      {isVolumeShow && (
        <VolumeDropDown
          volume={volume}
          setVolume={setVolume}
          setIsVolumeShow={setIsVolumeShow}
          isViewOnly={isViewOnly}
        />
      )}

      {isSettingsShow && (
        <SettingsDropdown
          setIsSettingsShow={setIsSettingsShow}
          playbackSpeed={playbackSpeed}
          setPlaybackSpeed={setPlaybackSpeed}
        />
      )}
    </Container>
  );
};

export default ControlsButton;

const Container = styled(FlexRowSpaced)<{
  $isVolumeShow: boolean;
  $isSettingsShow: boolean;
}>`
  position: relative;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  div:nth-child(2) > button[tabindex="0"] {
    background: ${({ theme, $isVolumeShow }) =>
      $isVolumeShow &&
      theme.Color.background.brand.subtler["default-active"].value};
    border-color: ${({ theme, $isVolumeShow }) =>
      $isVolumeShow && theme.Color.border["ui-border-emphasize-brand"].value};
  }
  div:nth-child(2) > button[tabindex="1"] {
    background: ${({ theme, $isSettingsShow }) =>
      $isSettingsShow &&
      theme.Color.background.brand.subtler["default-active"].value};
    border-color: ${({ theme, $isSettingsShow }) =>
      $isSettingsShow && theme.Color.border["ui-border-emphasize-brand"].value};
  }
`;
